import { Injectable } from "@angular/core";
import { QRScanner, QRScannerStatus } from "@ionic-native/qr-scanner";


@Injectable()
export class ScanService {

    constructor(private qrScanner: QRScanner) { }

    public startScanner():Promise<any> {
        // Optionally request the permission early
        return this.qrScanner.prepare()
            .then((status: QRScannerStatus) => {
                return new Promise((resolve, reject) => {
                    if (status.authorized) {
                        // camera permission was granted

                        const ionApp = <HTMLElement>document.getElementsByTagName("ion-app")[0];
                        // start scanning
                        let scanSub = this.qrScanner.scan().subscribe((text: string) => {
                            console.log('text: '+ JSON.stringify(text));
                        
                            this.qrScanner.hide(); // hide camera preview
                            scanSub.unsubscribe(); // stop scanning

                            ionApp.style.display = "block";
                            setTimeout(() => {
                                document.getElementsByTagName("body")[0].style.backgroundColor = "white";
                            }, 500);
                            resolve(text);
                        });

                        ionApp.style.display = "none";
                        this.qrScanner.show();
                    } else if (status.denied) {
                        this.qrScanner.openSettings();
                        reject(new Error('MESSAGES.QRSCANNER.CHANGE_SETTINGS_ERROR'));
                    } else {
                        reject(new Error('MESSAGES.QRSCANNER.PERMISSION_DENIED_ERROR'));
                    }
                })
            })
    }

    
}


// WEBPACK FOOTER //
// /src/providers/scan.service.ts